import { render, staticRenderFns } from "./Right.vue?vue&type=template&id=ace98d4c&scoped=true&"
import script from "./Right.vue?vue&type=script&lang=js&"
export * from "./Right.vue?vue&type=script&lang=js&"
import style0 from "./Right.vue?vue&type=style&index=0&id=ace98d4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace98d4c",
  null
  
)

export default component.exports